import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAdmin } = useAuth();
  const { t } = useLanguage();

  if (isAdmin) return <Navigate to="/admin" />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try { await login(username, password); } catch (err) { setError(t('invalidCredentials')); }
    setLoading(false);
  };

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="login-page">
      <div className="card p-8 w-full max-w-md">
        <h1 className="font-display font-bold text-2xl text-[#1E3A5F] text-center mb-6">{t('loginTitle')}</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">{t('username')}</label>
            <input type="text" value={username} onChange={e => setUsername(e.target.value)} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#1E3A5F] focus:border-transparent" data-testid="login-username" />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">{t('password')}</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#1E3A5F] focus:border-transparent" data-testid="login-password" />
          </div>
          {error && <p className="text-red-500 text-sm" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} className="w-full btn-primary" data-testid="login-submit">
            {loading ? t('loggingIn') : t('login')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
